import React, { useState } from 'react';
import { ReactComponent as ClearIcon } from '../Icons/shared/ic-shared-clear.svg';
import { ReactComponent as SearchIcon } from '../Icons/shared/ic-shared-search.svg';

export interface LiliSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeHolder: string;
  maxLength?: number;
}

export const LiliSearchBar = ({
  value, onChange, onClear, placeHolder, maxLength,
}: LiliSearchBarProps) => {
  const elInput = React.useRef<HTMLInputElement>(null);
  const [isFieldOnFocus, setIsFieldOnFocus] = useState<boolean>(false);

  return (
    <div className={`flex items-center bg-bw02 py-[8px] px-[14px] rounded-[8px] border hover:border-bw08 ${(isFieldOnFocus || value) ? 'border-bw07' : 'border-bw04'} transition-all ease-in`}>
      <button onClick={() => elInput.current?.focus()} type='button' className='mr-[6px]'>
        <SearchIcon />
      </button>
      <input
        maxLength={maxLength}
        max={maxLength}
        ref={elInput}
        onChange={(e) => onChange(e.target.value.trimStart())}
        className={`bg-transparent w-full outline-none placeholder:font-metricR placeholder-bw06 ${isFieldOnFocus ? 'placeholder:opacity-65' : 'placeholder:opacity-100'} text-bw07 text-[14px] font-metricR`}
        onFocus={() => setIsFieldOnFocus(true)}
        onBlur={() => setIsFieldOnFocus(false)}
        type='text'
        placeholder={placeHolder}
        value={value}
      />
      <button onClick={onClear} type='button' className={`ml-auto ${value ? 'inline-block' : 'hidden'}`}>
        <ClearIcon />
      </button>
    </div>
  );
};
